import Vue from 'vue'
import Router from 'vue-router'
import MainService from '@/components/main'
import AuthService from '@/components/auth'
import PortalService from '@/components/portal'

Vue.use(Router)

MainService.routes[0].children = [
  ...PortalService.routes
]

let routes = [
  MainService.routes[0]
]

// Import Registered Services
importServices([
  AuthService
])

// Initialize Router
let router = new Router({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  EventBus.$emit('page:loading', true)
  next()
})

async function importServices(services) {
  for (let i = 0; i < services.length; i++) {
    let service = services[i]
    routes = routes.concat(service.routes)
  }
}

export default router